var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignInLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 148,
    viewBox: "0 0 199 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4622 40.3176C42.6678 40.4233 42.8918 40.5384 40 40.5384C40.4428 38.2812 41.0225 36.0653 41.7346 33.9092C42.3485 31.8173 43.0687 29.7726 43.891 27.786H51.2041C52.9412 29.3003 55.0596 30.054 57.2048 29.9208C58.6549 29.785 60.0552 29.2254 61.2834 28.2914C69.8009 23.2655 78.7435 19.3484 87.9579 16.6068C97.6759 13.7543 107.629 12.209 117.633 12C128.407 12.4536 139.139 13.843 149.746 16.1573C161.873 18.8281 173.792 22.7182 185.374 27.786C186.406 28.1231 187.296 28.5164 188.047 28.8534C189.687 29.5276 190.297 29.9208 190.672 30.6511C190.853 31.0307 190.965 31.4517 191 31.8869L190.25 44.1898C190.104 44.9284 189.797 45.607 189.359 46.1558C188.8 46.8448 188.049 47.2646 187.25 47.3357C184.956 47.4565 182.734 48.3312 180.827 49.8638C179.355 51.1995 178.132 52.8888 177.236 54.8235C176.34 56.7582 175.791 58.8957 175.623 61.0993C174.63 69.4604 173.062 77.7091 170.935 85.7613C169.067 93.0263 166.731 100.107 163.95 106.94C158.393 117.586 150.623 126.32 141.403 132.287C132.183 138.255 121.828 141.251 111.351 140.984C102.573 140.551 93.9743 137.864 86.1372 133.105C78.3002 128.347 71.4073 121.627 65.9245 113.401C55.6106 96.9655 49.7232 77.1529 49.0477 56.6051C50.317 55.4105 51.3296 53.8694 52.0011 52.1107C53.009 50.188 53.3457 47.8679 52.9387 45.6504C52.4568 44.4108 51.7319 43.3291 50.8258 42.4977C49.9197 41.6662 48.8594 41.1095 47.735 40.8751C46.471 40.5149 45.1859 40.2711 43.8909 40.1452C42.1268 40.1452 42.2879 40.228 42.4622 40.3176ZM57.5459 45.5677C56.8832 49.7679 56.2233 53.9507 53.8163 57.8818C54.4475 77.111 59.9491 95.6522 69.5871 111.033C74.7106 118.731 81.1518 125.02 88.4753 129.473C95.7987 133.926 103.834 136.44 112.037 136.846C121.827 137.096 131.504 134.292 140.12 128.707C148.736 123.123 155.996 114.949 161.189 104.987C163.788 98.592 165.97 91.9658 167.716 85.167C169.703 77.6315 174.566 39.9385 174.566 33.7299C172.582 30.2808 159.248 22.529 147.915 20.0295C138.004 17.8638 127.975 16.5635 117.907 16.139C108.559 16.3346 99.2578 17.7807 90.1766 20.4502C81.5661 23.0159 75.4215 24.8875 67.4621 29.5909C66.9898 29.9506 66.1864 30.3181 65.2809 30.7323C63.986 31.3247 62.4823 32.0125 61.4389 32.9098C58.9005 36.9814 58.2217 41.2836 57.5459 45.5677Z",
    fill: "#406272",
    stroke: "#7EA7BA",
    strokeWidth: 14,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.67 36.6515C24.8929 36.7576 25.1358 36.8733 22 36.8733C22.4801 34.6063 23.1088 32.381 23.8809 30.2157C24.5467 28.1149 25.3276 26.0614 26.2194 24.0664H34.1496C36.0333 25.5871 38.3304 26.344 40.6566 26.2103C42.2291 26.0738 43.7476 25.5119 45.0793 24.5739C54.3157 19.5265 64.0128 15.5927 74.0048 12.8393C84.5429 9.97466 95.3362 8.42279 106.184 8.21289C117.867 8.66838 129.505 10.0638 141.007 12.3879C154.158 15.0702 167.082 18.9768 179.642 24.0664C180.76 24.4049 181.726 24.7998 182.539 25.1383C184.319 25.8153 184.98 26.2103 185.386 26.9437C185.583 27.3248 185.704 27.7477 185.742 28.1847L184.929 40.5402C184.771 41.282 184.437 41.9634 183.963 42.5147C183.356 43.2066 182.543 43.6282 181.675 43.6996C179.188 43.8209 176.778 44.6993 174.711 46.2384C173.114 47.5798 171.788 49.2764 170.816 51.2194C169.845 53.1623 169.249 55.3089 169.068 57.5219C167.99 65.9188 166.29 74.2027 163.984 82.2893C161.958 89.5854 159.426 96.6962 156.41 103.558C150.383 114.25 141.958 123.021 131.96 129.014C121.962 135.007 110.733 138.016 99.3721 137.747C89.853 137.313 80.5289 134.615 72.0305 129.836C63.5321 125.057 56.0576 118.308 50.1121 110.047C38.9278 93.5413 32.5437 73.6442 31.8111 53.0086C33.1875 51.8089 34.2856 50.2611 35.0138 48.4949C36.1067 46.5641 36.4719 44.234 36.0305 42.0071C35.5079 40.7622 34.7219 39.6758 33.7393 38.8408C32.7568 38.0058 31.6069 37.4467 30.3877 37.2114C29.0171 36.8497 27.6235 36.6048 26.2192 36.4783C24.3062 36.4783 24.4809 36.5615 24.67 36.6515ZM41.0265 41.924C40.3079 46.1421 39.5923 50.3428 36.9821 54.2907C37.6667 73.6021 43.6325 92.2224 54.0838 107.669C59.6396 115.4 66.6244 121.715 74.5658 126.188C82.5073 130.66 91.2204 133.185 100.116 133.592C110.732 133.843 121.225 131.027 130.568 125.419C139.911 119.81 147.784 111.602 153.416 101.597C156.234 95.1748 158.6 88.5203 160.494 81.6924C162.648 74.1248 167.921 36.2708 167.921 30.0357C165.77 26.5717 151.311 18.7869 139.022 16.2767C128.274 14.1017 117.399 12.7959 106.481 12.3696C96.3442 12.566 86.2583 14.0183 76.4108 16.6992C67.0736 19.2759 60.4105 21.1555 51.7795 25.879C51.2673 26.2402 50.3962 26.6092 49.4142 27.0252C48.0101 27.6201 46.3794 28.3109 45.248 29.2121C42.4954 33.301 41.7594 37.6216 41.0265 41.924Z",
    fill: "#003366",
    stroke: "#003366",
    strokeWidth: 16,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.963 97.987L150.114 107.868C154.754 109.766 160.054 107.543 161.953 102.903L163.487 99.1523C165.386 94.5124 163.163 89.2121 158.523 87.3139L134.372 77.4333C129.732 75.535 124.431 77.7576 122.533 82.3975L120.999 86.1485C119.1 90.7885 121.323 96.0888 125.963 97.987Z",
    fill: "url(#paint0_linear_1959_12235)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.961 66.1823L161.112 76.0629C165.752 77.9612 171.053 75.7386 172.951 71.0986L174.485 67.3476C176.384 62.7077 174.161 57.4074 169.521 55.5092L145.37 45.6286C140.73 43.7303 135.429 45.9529 133.531 50.5929L131.997 54.3439C130.098 58.9838 132.321 64.2841 136.961 66.1823Z",
    fill: "url(#paint1_linear_1959_12235)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.306 87.893L77.0739 112.378C73.2307 115.597 72.7248 121.323 75.9439 125.166L78.5463 128.273C81.7654 132.116 87.4905 132.622 91.3336 129.403L120.566 104.917C124.409 101.698 124.915 95.973 121.696 92.1299L119.094 89.023C115.874 85.1798 110.149 84.6739 106.306 87.893Z",
    fill: "url(#paint2_linear_1959_12235)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.527 44.9613C151.004 44.8053 157.828 37.8849 157.828 29.3707C157.828 20.7587 150.846 13.7773 142.234 13.7773C133.622 13.7773 126.641 20.7587 126.641 29.3707C126.641 32.9993 127.88 36.3385 129.959 38.9879C126.62 39.3154 123.592 41.4888 122.337 44.8427L104.516 92.4571C102.759 97.1522 105.14 102.383 109.835 104.14L113.631 105.561C118.326 107.318 123.557 104.937 125.314 100.242L143.135 52.6271C144.116 50.0063 143.808 47.2186 142.527 44.9613Z",
    fill: "url(#paint3_linear_1959_12235)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6953 45.3093L116.847 55.1899C121.487 57.0881 126.787 54.8655 128.685 50.2256L130.22 46.4746C132.118 41.8346 129.895 36.5344 125.255 34.6361L101.104 24.7555C96.4641 22.8573 91.1639 25.0798 89.2656 29.7198L87.731 33.4708C85.8328 38.1107 88.0553 43.411 92.6953 45.3093Z",
    fill: "url(#paint4_linear_1959_12235)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.903 38.6497L152.231 63.2609C150.565 67.9892 153.048 73.1728 157.776 74.8389L161.599 76.1857C166.327 77.8517 171.511 75.3693 173.177 70.6409L181.848 46.0297C183.514 41.3014 181.032 36.1177 176.304 34.4517L172.481 33.1049C167.753 31.4389 162.569 33.9213 160.903 38.6497Z",
    fill: "url(#paint5_linear_1959_12235)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.349 91.3391L133.677 115.95C132.011 120.679 134.493 125.862 139.222 127.528L143.044 128.875C147.772 130.541 152.956 128.059 154.622 123.33L163.294 98.7192C164.96 93.9909 162.477 88.8072 157.749 87.1412L153.927 85.7944C149.198 84.1283 144.015 86.6108 142.349 91.3391Z",
    fill: "url(#paint6_linear_1959_12235)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 66,
    r: 58,
    fill: "#1A355F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 62,
    r: 61,
    fill: "#CCD6DA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0056 96C43.1048 96 40.8787 95.1597 39.3272 93.479C37.7785 91.7983 37 89.5463 37 86.6303V34.3278C37 31.2857 37.7921 28.9692 39.3764 27.3782C40.9606 25.7872 43.2031 24.9944 46.1039 25H69.8922C77.573 25 83.5112 27.0337 87.7067 31.1009C91.9022 35.1681 94 40.7703 94 47.9076C94 55.056 91.9022 60.6583 87.7067 64.7143C83.5112 68.7703 77.573 70.8236 69.8922 70.874H54.8227V86.6639C54.8227 89.5798 54.0607 91.8572 52.5447 93.5126C51.0288 95.1681 48.8491 96 46.0056 96ZM54.8227 56.8824H66.7292C70.1544 56.8824 72.7356 56.1373 74.4728 54.6471C76.21 53.1569 77.0841 50.916 77.095 47.9244C77.095 44.9496 76.2209 42.7087 74.4728 41.2017C72.7247 39.6947 70.1435 38.9496 66.7292 38.9664H54.8227V56.8824Z",
    fill: "#40668C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1959_12235",
    x1: 154.78,
    y1: 132.54,
    x2: 105.322,
    y2: 107.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1959_12235",
    x1: 165.778,
    y1: 100.735,
    x2: 116.32,
    y2: 75.8219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1959_12235",
    x1: 52.1178,
    y1: 105.799,
    x2: 110.235,
    y2: 66.2259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1959_12235",
    x1: 98.356,
    y1: -73.8479,
    x2: 165.972,
    y2: -72.2948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1959_12235",
    x1: 121.512,
    y1: 79.8619,
    x2: 72.0539,
    y2: 54.9489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1959_12235",
    x1: 127.821,
    y1: 69.1431,
    x2: 150.253,
    y2: 18.5112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1959_12235",
    x1: 109.266,
    y1: 121.833,
    x2: 131.698,
    y2: 71.2007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInLogo);
export default __webpack_public_path__ + "static/media/sign-in-logo.d550b85dbf4c8c2d083d8cebffc87244.svg";
export { ForwardRef as ReactComponent };